import { SparkleIcon as PhosphorSparkleIcon } from "@phosphor-icons/react/dist/ssr/Sparkle";

import { createAppIcon } from "@/components/createAppIcon";

export const SparkleIcon = /* @__PURE__ */ createAppIcon(PhosphorSparkleIcon);
